<template>
    <base-modal
        modal-id="regionModal"
        modal-dialog="centered,region"
    >
        <template #title><h5 class="modal-title glitch-text glitch-text--modal-region">Ваш город</h5></template>
        <template #default="{ isOpen }">
            <region-selection :is-open="isOpen"/>
        </template>

    </base-modal>
</template>

<script>
import BaseModal from './base-modal';
import RegionSelection from '../region-selection';

export default {
    name: 'region-selection-modal',

    components: { RegionSelection, BaseModal },

    data() {
        return {
            count: 1,
        };
    },
};
</script>
